'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_DrawerSignals(incomingDrugRequests, outgoingDrugRequestPharmacyResponses, unreadChats, unreadAcceptedDrugRequestsWithoutEPSCode, unreadAcceptedDrugRequests, unreadOutOfStockMedicationReports) {
  this.Lapp_data_DrawerSignals__f_incomingDrugRequests = null;
  this.Lapp_data_DrawerSignals__f_outgoingDrugRequestPharmacyResponses = null;
  this.Lapp_data_DrawerSignals__f_unreadChats = null;
  this.Lapp_data_DrawerSignals__f_unreadAcceptedDrugRequestsWithoutEPSCode = null;
  this.Lapp_data_DrawerSignals__f_unreadAcceptedDrugRequests = null;
  this.Lapp_data_DrawerSignals__f_unreadOutOfStockMedicationReports = null;
  this.Lapp_data_DrawerSignals__f_generalPracticeUnreadItemCount$lzy1 = null;
  this.Lapp_data_DrawerSignals__f_generalPracticeUnreadItemCountbitmap$1 = false;
  this.Lapp_data_DrawerSignals__f_pharmacyUnreadItemCount$lzy1 = null;
  this.Lapp_data_DrawerSignals__f_pharmacyUnreadItemCountbitmap$1 = false;
  this.Lapp_data_DrawerSignals__f_pharmacyDrugRequestsWithChats$lzy1 = null;
  this.Lapp_data_DrawerSignals__f_pharmacyDrugRequestsWithChatsbitmap$1 = false;
  this.Lapp_data_DrawerSignals__f_hasNewDrugRequests = null;
  this.Lapp_data_DrawerSignals__f_hasNewOutgoingDrugRequestPharmacyResponses = null;
  this.Lapp_data_DrawerSignals__f_hasUnreadChats = null;
  this.Lapp_data_DrawerSignals__f_hasUnreadIncomingDrugRequests = null;
  this.Lapp_data_DrawerSignals__f_hasUnreadAcceptedDrugRequests = null;
  this.Lapp_data_DrawerSignals__f_hasUnreadAcceptedDrugRequestsWithoutEPSCode = null;
  this.Lapp_data_DrawerSignals__f_hasUnreadOutOfStockMedicationReports = null;
  this.Lapp_data_DrawerSignals__f_mainMenuIndicator = null;
  this.Lapp_data_DrawerSignals__f_incomingDrugRequests = incomingDrugRequests;
  this.Lapp_data_DrawerSignals__f_outgoingDrugRequestPharmacyResponses = outgoingDrugRequestPharmacyResponses;
  this.Lapp_data_DrawerSignals__f_unreadChats = unreadChats;
  this.Lapp_data_DrawerSignals__f_unreadAcceptedDrugRequestsWithoutEPSCode = unreadAcceptedDrugRequestsWithoutEPSCode;
  this.Lapp_data_DrawerSignals__f_unreadAcceptedDrugRequests = unreadAcceptedDrugRequests;
  this.Lapp_data_DrawerSignals__f_unreadOutOfStockMedicationReports = unreadOutOfStockMedicationReports;
  var project = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$7) => {
    var _$7$1 = (_$7 | 0);
    return (_$7$1 > 0);
  }));
  var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), incomingDrugRequests, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  this.Lapp_data_DrawerSignals__f_hasNewDrugRequests = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable(this$1);
  var project$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$8) => {
    var _$8$1 = (_$8 | 0);
    return (_$8$1 > 0);
  }));
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), outgoingDrugRequestPharmacyResponses, project$1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  this.Lapp_data_DrawerSignals__f_hasNewOutgoingDrugRequestPharmacyResponses = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable(this$2);
  var project$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$9) => {
    var _$9$1 = (_$9 | 0);
    return (_$9$1 > 0);
  }));
  var this$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), unreadChats, project$2, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  this.Lapp_data_DrawerSignals__f_hasUnreadChats = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable(this$3);
  var signal = this.Lapp_data_DrawerSignals__f_hasUnreadChats;
  var s1 = this.Lapp_data_DrawerSignals__f_hasNewDrugRequests;
  var combinator = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(((_$10, _$11) => {
    var _$10$1 = (!(!_$10));
    var _$11$1 = (!(!_$11));
    return (_$10$1 || _$11$1);
  }));
  this.Lapp_data_DrawerSignals__f_hasUnreadIncomingDrugRequests = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().combineWithFn__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_Source$SignalSource__F2__Lcom_raquo_airstream_core_Signal(signal, s1, combinator);
  var project$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$12) => {
    var _$12$1 = (_$12 | 0);
    return (_$12$1 > 0);
  }));
  var this$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), unreadAcceptedDrugRequests, project$3, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  this.Lapp_data_DrawerSignals__f_hasUnreadAcceptedDrugRequests = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable(this$6);
  var project$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$13) => {
    var _$13$1 = (_$13 | 0);
    return (_$13$1 > 0);
  }));
  var this$7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), unreadAcceptedDrugRequestsWithoutEPSCode, project$4, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  this.Lapp_data_DrawerSignals__f_hasUnreadAcceptedDrugRequestsWithoutEPSCode = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable(this$7);
  var project$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$14) => {
    var _$14$1 = (_$14 | 0);
    return (_$14$1 > 0);
  }));
  var this$8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), unreadOutOfStockMedicationReports, project$5, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  this.Lapp_data_DrawerSignals__f_hasUnreadOutOfStockMedicationReports = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable(this$8);
  var signal$1 = this.Lapp_data_DrawerSignals__f_hasNewDrugRequests;
  var s1$1 = this.Lapp_data_DrawerSignals__f_hasNewOutgoingDrugRequestPharmacyResponses;
  var s2 = this.Lapp_data_DrawerSignals__f_hasUnreadChats;
  var s3 = this.Lapp_data_DrawerSignals__f_hasUnreadAcceptedDrugRequests;
  var s4 = this.Lapp_data_DrawerSignals__f_hasUnreadAcceptedDrugRequestsWithoutEPSCode;
  var s5 = this.Lapp_data_DrawerSignals__f_hasUnreadOutOfStockMedicationReports;
  var combinator$1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sr_AbstractFunction6_$$Lambda$a99c8f90daf3b5626ca3b2aaf61c97e045a5237f(((_$15, _$16, _$17, _$18, _$19, _$20) => {
    var _$15$1 = (!(!_$15));
    var _$16$1 = (!(!_$16));
    var _$17$1 = (!(!_$17));
    var _$18$1 = (!(!_$18));
    var _$19$1 = (!(!_$19));
    var _$20$1 = (!(!_$20));
    return (((((_$15$1 || _$16$1) || _$17$1) || _$18$1) || _$19$1) || _$20$1);
  }));
  this.Lapp_data_DrawerSignals__f_mainMenuIndicator = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().combineWithFn__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_Source$SignalSource__F6__Lcom_raquo_airstream_core_Signal(signal$1, s1$1, s2, s3, s4, s5, combinator$1);
}
export { $c_Lapp_data_DrawerSignals as $c_Lapp_data_DrawerSignals };
$c_Lapp_data_DrawerSignals.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_DrawerSignals.prototype.constructor = $c_Lapp_data_DrawerSignals;
/** @constructor */
function $h_Lapp_data_DrawerSignals() {
}
export { $h_Lapp_data_DrawerSignals as $h_Lapp_data_DrawerSignals };
$h_Lapp_data_DrawerSignals.prototype = $c_Lapp_data_DrawerSignals.prototype;
$c_Lapp_data_DrawerSignals.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_data_DrawerSignals.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 460565244, true);
});
$c_Lapp_data_DrawerSignals.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_DrawerSignals)) {
    var x = this.Lapp_data_DrawerSignals__f_incomingDrugRequests;
    var x$2 = x$0.Lapp_data_DrawerSignals__f_incomingDrugRequests;
    if ((x === x$2)) {
      var x$3 = this.Lapp_data_DrawerSignals__f_outgoingDrugRequestPharmacyResponses;
      var x$4 = x$0.Lapp_data_DrawerSignals__f_outgoingDrugRequestPharmacyResponses;
      var $x_4 = (x$3 === x$4);
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$5 = this.Lapp_data_DrawerSignals__f_unreadChats;
      var x$6 = x$0.Lapp_data_DrawerSignals__f_unreadChats;
      var $x_3 = (x$5 === x$6);
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$7 = this.Lapp_data_DrawerSignals__f_unreadAcceptedDrugRequestsWithoutEPSCode;
      var x$8 = x$0.Lapp_data_DrawerSignals__f_unreadAcceptedDrugRequestsWithoutEPSCode;
      var $x_2 = (x$7 === x$8);
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$9 = this.Lapp_data_DrawerSignals__f_unreadAcceptedDrugRequests;
      var x$10 = x$0.Lapp_data_DrawerSignals__f_unreadAcceptedDrugRequests;
      var $x_1 = (x$9 === x$10);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$11 = this.Lapp_data_DrawerSignals__f_unreadOutOfStockMedicationReports;
      var x$12 = x$0.Lapp_data_DrawerSignals__f_unreadOutOfStockMedicationReports;
      return (x$11 === x$12);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lapp_data_DrawerSignals.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_data_DrawerSignals.prototype.productArity__I = (function() {
  return 6;
});
$c_Lapp_data_DrawerSignals.prototype.productPrefix__T = (function() {
  return "DrawerSignals";
});
$c_Lapp_data_DrawerSignals.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lapp_data_DrawerSignals__f_incomingDrugRequests;
      break;
    }
    case 1: {
      return this.Lapp_data_DrawerSignals__f_outgoingDrugRequestPharmacyResponses;
      break;
    }
    case 2: {
      return this.Lapp_data_DrawerSignals__f_unreadChats;
      break;
    }
    case 3: {
      return this.Lapp_data_DrawerSignals__f_unreadAcceptedDrugRequestsWithoutEPSCode;
      break;
    }
    case 4: {
      return this.Lapp_data_DrawerSignals__f_unreadAcceptedDrugRequests;
      break;
    }
    case 5: {
      return this.Lapp_data_DrawerSignals__f_unreadOutOfStockMedicationReports;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lapp_data_DrawerSignals.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "incomingDrugRequests";
      break;
    }
    case 1: {
      return "outgoingDrugRequestPharmacyResponses";
      break;
    }
    case 2: {
      return "unreadChats";
      break;
    }
    case 3: {
      return "unreadAcceptedDrugRequestsWithoutEPSCode";
      break;
    }
    case 4: {
      return "unreadAcceptedDrugRequests";
      break;
    }
    case 5: {
      return "unreadOutOfStockMedicationReports";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lapp_data_DrawerSignals.prototype.generalPracticeUnreadItemCount__Lcom_raquo_airstream_core_Signal = (function() {
  if ((!this.Lapp_data_DrawerSignals__f_generalPracticeUnreadItemCountbitmap$1)) {
    var signal = this.Lapp_data_DrawerSignals__f_outgoingDrugRequestPharmacyResponses;
    var s1 = this.Lapp_data_DrawerSignals__f_unreadChats;
    var s2 = this.Lapp_data_DrawerSignals__f_unreadAcceptedDrugRequestsWithoutEPSCode;
    var s3 = this.Lapp_data_DrawerSignals__f_unreadOutOfStockMedicationReports;
    var combinator = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sr_AbstractFunction4_$$Lambda$44dd8b4a36ad9db1c12297bcc97fced51ec30e4c(((_$1, _$2, _$3, _$4) => {
      var _$1$1 = (_$1 | 0);
      var _$2$1 = (_$2 | 0);
      var _$3$1 = (_$3 | 0);
      var _$4$1 = (_$4 | 0);
      return ((((((_$1$1 + _$2$1) | 0) + _$3$1) | 0) + _$4$1) | 0);
    }));
    this.Lapp_data_DrawerSignals__f_generalPracticeUnreadItemCount$lzy1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().combineWithFn__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_Source$SignalSource__F4__Lcom_raquo_airstream_core_Signal(signal, s1, s2, s3, combinator));
    this.Lapp_data_DrawerSignals__f_generalPracticeUnreadItemCountbitmap$1 = true;
  }
  return this.Lapp_data_DrawerSignals__f_generalPracticeUnreadItemCount$lzy1;
});
$c_Lapp_data_DrawerSignals.prototype.pharmacyUnreadItemCount__Lcom_raquo_airstream_core_Signal = (function() {
  if ((!this.Lapp_data_DrawerSignals__f_pharmacyUnreadItemCountbitmap$1)) {
    var signal = this.pharmacyDrugRequestsWithChats__Lcom_raquo_airstream_core_Signal();
    var s1 = this.Lapp_data_DrawerSignals__f_unreadAcceptedDrugRequests;
    var combinator = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(((_$5, _$6) => {
      var _$5$1 = (_$5 | 0);
      var _$6$1 = (_$6 | 0);
      return ((_$5$1 + _$6$1) | 0);
    }));
    this.Lapp_data_DrawerSignals__f_pharmacyUnreadItemCount$lzy1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().combineWithFn__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_Source$SignalSource__F2__Lcom_raquo_airstream_core_Signal(signal, s1, combinator));
    this.Lapp_data_DrawerSignals__f_pharmacyUnreadItemCountbitmap$1 = true;
  }
  return this.Lapp_data_DrawerSignals__f_pharmacyUnreadItemCount$lzy1;
});
$c_Lapp_data_DrawerSignals.prototype.pharmacyDrugRequestsWithChats__Lcom_raquo_airstream_core_Signal = (function() {
  if ((!this.Lapp_data_DrawerSignals__f_pharmacyDrugRequestsWithChatsbitmap$1)) {
    var signal = this.Lapp_data_DrawerSignals__f_incomingDrugRequests;
    var s1 = this.Lapp_data_DrawerSignals__f_unreadChats;
    var combinator = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(((x, y) => {
      var x$1 = (x | 0);
      var y$1 = (y | 0);
      return ((x$1 > y$1) ? x$1 : y$1);
    }));
    this.Lapp_data_DrawerSignals__f_pharmacyDrugRequestsWithChats$lzy1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_combine_generated_StaticSignalCombineOps$().combineWithFn__Lcom_raquo_airstream_core_Source$SignalSource__Lcom_raquo_airstream_core_Source$SignalSource__F2__Lcom_raquo_airstream_core_Signal(signal, s1, combinator));
    this.Lapp_data_DrawerSignals__f_pharmacyDrugRequestsWithChatsbitmap$1 = true;
  }
  return this.Lapp_data_DrawerSignals__f_pharmacyDrugRequestsWithChats$lzy1;
});
function $isArrayOf_Lapp_data_DrawerSignals(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_data_DrawerSignals)));
}
export { $isArrayOf_Lapp_data_DrawerSignals as $isArrayOf_Lapp_data_DrawerSignals };
var $d_Lapp_data_DrawerSignals = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_DrawerSignals, "app.data.DrawerSignals", ({
  Lapp_data_DrawerSignals: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_data_DrawerSignals as $d_Lapp_data_DrawerSignals };
//# sourceMappingURL=app.data.-Drawer-Signals.js.map
